import PageShell from "@/components/site/PageShell";
import PageHero from "@/components/site/PageHero";
import { usePageContent } from "@/i18n/pageContent";

function renderInline(text) {
  if (!text) return null;
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) => p.startsWith("**") && p.endsWith("**")
    ? <strong key={i} className="text-[#1a365d]">{p.slice(2, -2)}</strong>
    : <span key={i}>{p}</span>);
}

export default function EULanguages() {
  const c = usePageContent("euLanguages");
  const official = c.official || [];
  return (
    <PageShell>
      <PageHero
        eyebrow={c.eyebrow}
        title={<>{c.titleA} <span className="italic">{c.titleB}</span>.</>}
        subtitle={c.subtitle}
        image="/eu-languages-hero.webp"
        imageFit="contain"
      />
      <section className="bg-white py-20 md:py-28">
        <div className="max-w-3xl mx-auto px-6 md:px-10 space-y-6 text-[#1e293b] leading-[1.9] text-base md:text-[17px] reveal">
          <p>{c.p1}</p>
          <p>{c.p2}</p>
          <p>{renderInline(c.p3)}</p>
        </div>
      </section>

      <section className="bg-[#fafaf7] py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="mb-10 reveal">
            <span className="eyebrow">{c.gridEyebrow}</span>
            <h2 className="font-display text-3xl md:text-5xl text-[#1a365d] mt-4 leading-tight">
              {c.gridTitle1} <span className="italic">{c.gridTitle2}</span>.
            </h2>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {official.map((lang, i) => (
              <div key={lang} className={`bg-white border border-[#e2e8f0] hover:border-[#d4af37] transition-colors p-5 reveal delay-${(i % 4) + 1}`}>
                <div className="text-[10.5px] tracking-[0.32em] uppercase text-[#d4af37] font-body">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="font-display text-xl text-[#1a365d] mt-1.5 leading-tight">
                  {lang}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white py-20 md:py-28">
        <div className="max-w-3xl mx-auto px-6 md:px-10 reveal">
          <blockquote className="border-l-2 border-[#d4af37] pl-6 font-display text-2xl md:text-3xl text-[#1a365d] leading-[1.3] italic">
            &quot;{c.quote}&quot;
          </blockquote>
          <p className="mt-8 text-[#475569] leading-[1.9] text-base md:text-[17px]">
            {c.closing}
          </p>
        </div>
      </section>
    </PageShell>
  );
}
